export default __webpack_public_path__ + "0dc85bf69f4b2f9038bb09e98ecf2d38.png";